import { Box, IconButton, Typography, makeStyles, Grid, InputAdornment, MenuItem, alpha, useTheme } from '@material-ui/core'
import { Delete, Description } from '@material-ui/icons'

import MROFullScreenRightDrawer from 'components/fullwidth_dialog'
import GetInfoCard from 'components/GetInfoCard'
import SearchBarWithFilters from 'components/search_with_filters'
import ToolBar from 'components/ToolBar'
import tableIcons, { options } from 'components/universal/table_attributes'
import useDebounce from 'lib/utils/debounce'
import MaterialTable from 'material-table'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import QuantityCounter from "components/quantity_counter";
import MROTextField from 'components/form_components/TextField'
import MROButton from 'components/buttons'
import PartSalesServices from 'lib/services/api/commercial/parts'
import { formatDateFunction, getOrganisationId, getUserId } from 'lib/utils/common_utils'
import MultipleSearchableDropdown from 'components/universal/multipleSearchableDropDown'
import moment from 'moment'
import { validateFormData } from 'lib/utils/helperFunctions'
import { MaintenanceServices } from 'lib/services/api/operaitons/WorkShop/TaskLibrary/Maintenance/maintenance_operation'
import { ToastMessageContext } from 'lib/contexts/message_context'
import workshopCustomerClient from 'lib/services/api/admin/workshop/workshop_customer_client'
import TraceRequirements from './TraceRequirements'
import TouchAppIcon from "@material-ui/icons/TouchApp";
import PartPricing from 'views/Operations/Workshop/Commercial/LookupPricing/PartPricing'

const useStyles = makeStyles(theme => ({
    wrapper: {

        margin: "2% 3%",
    },
    partCard: {
        borderRadius: "8px",
        padding: "7px 24px",
    },
    disableField: {
        pointerEvents: "none",
        backgroundColor: "#F5F5F5",
    },
}));

export default function ManageCreateCore(props) {

    const classes = useStyles()

    const { handleClose,
        action,
        disabled,
        s_data,
        defaultCurrency,
        currrencyDetails,
        quotationId,
        quotationDetails,
        currentSelection,
        tabName,
        setSData,
        coreId
    } = props

    const [searchText, setSearchText] = useState("")
    const debounceVal = useDebounce(searchText)
    const [cAction, setCAction] = useState(null)
    const [currentSelectedData, setCurrentSelectedData] = useState({})
    const theme = useTheme()
    const [tatQuantity, setTatquantity] = useState();
    const [qty, setQty] = useState(1);
    const [primePart, setPrimePart] = useState(null)
    const [errors, setErrors] = useState({});
    const [primaryDetails, setPrimaryDetails] = useState([])
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(5)
    const [totalCount, setTotalCount] = useState(0)

    //    


    const [loading, setLoading] = useState(null)

    const [linkedSales, setLinkedSales] = useState("")
    const [coreType, setCoreType] = useState("")
    const [unitValue, setUnitValue] = useState(0)
    const [lineTotal, setLineTotal] = useState("")
    const [shippingFee, setShippingFee] = useState(0)
    const [receiptType, setReceiptType] = useState("")
    const [lateCharge, setLateCharge] = useState("")

    const message = useContext(ToastMessageContext)
    const [data, setData] = useState([])
    const [traceData, setTraceData] = useState([])

    const [results, setResults] = useState({
        coreUnitValue: 0,
        coreLineTotal: 0,
        shipping: 0,
        lateCharge: 0,
    });

    const tableOptions = {
        ...options,
        page: page,
        total: totalCount,
        pageSize: pageSize,
        toolbar: false,
        search: false,

    };

    const columns = [

        {
            title: "Part #",
            field: "part_number",
            width: "15%",
            headerStyle: {
                paddingLeft: "19px",
                textAlign: "left",
            },
            cellStyle: {
                paddingLeft: "19px",
                textAlign: "left",
                width: "15%",
            },
        },
        {
            title: "Description",
            field: "description",
            headerStyle: {
                textAlign: "left",
                width: "30%",
            },
            cellStyle: {
                textAlign: "left",
                width: "30%",
            },
        },
        {
            title: "Unit Value",
            field: "unit_value",


        },
        {
            title: "Core Value",
            field: "core_value",

            render: (rowData) => rowData?.core_value || "-",
        },
        {
            title: "Currency",
            field: "currency",


        },
        {
            title: "Std Prices",
            field: "std_price",
            render: (rowData) => <a onClick={() => {
                setCAction("project_lookup")
                setCurrentSelectedData(rowData)
            }} style={{ textDecoration: "underline" }}>{rowData?.std_price}</a>

        },
        {
            title: "Action",
            render: (rowData) => (
                <IconButton onClick={() => {
                    setPrimaryDetails(rowData)
                    setUnitValue(rowData.core_value)
                }}>
                    <TouchAppIcon />
                </IconButton>
            ),
        },




    ]


    const handleTraceCalculation = (penalty = 0, total = 0) => {
        const p = parseFloat(penalty) || 0;
        const t = parseFloat(total) || 0;
        const result = (p / 100) * t;
        return isNaN(result) ? "0.00" : result.toFixed(2);
    };

    useEffect(() => {
        const params = {
            organisation_id: getOrganisationId(),
            page: page + 1,
            count_per_page: pageSize,
            search_keyword: debounceVal


        }
        setLoading(true)


        PartSalesServices.getAllRepaiablePArts(params)
            .then((res) => {
                if (res?.data.length > 0) {
                    let value = res?.data.map((item) => {
                        let obj = {
                            name: item.part_number,
                            id: item.primary_part_id

                        }
                        return { ...item, ...obj }
                    })
                    setPrimePart(value);
                    setData(res.data)
                }
                else {
                    setPrimePart(res.data)
                    setData(res.data)
                }


                setTotalCount(res?.total_count)



            }).catch(() => {
                console.log("error")
            }).finally(() => {
                setLoading(false)
            })






    }, [page, pageSize, debounceVal])


    useEffect(() => {
        if (tabName === "core_exchange" && quotationId) {
            const getDetails = async () => {
                const params = {
                    organisation_id: getOrganisationId(),
                    sales_order_id: quotationId

                }
                try {
                    const response = await PartSalesServices.getQuoteSaleItemDetails(params)
                    setSData(response?.data)
                } catch (error) {

                }
            }

            getDetails()
        }
    }, [tabName, quotationId])

    // const get trace 
    const getTraceRequirement = () => {
        const params = {
            organisation_id: getOrganisationId(),
            state: "Active",
        }
        if (action === "view") {
            params["sales_order_core_id"] = currentSelection?.id;
        }
        PartSalesServices.getTraceRequirement(params).then((res) => {

            let data = res?.data

            if (data.length > 0) {
                const total = calculateValue(+currentSelection?.core_line_total || 0, rate);

                const formattedData = data.map((item) => ({
                    ...item,
                    status: action === "view" ? item?.trace_state : false,
                    currency: currrencyDetails?.currency_name,
                    value: handleTraceCalculation(item.penalty_pc, total),
                }));

                setTraceData(formattedData);
            }
            else {
                setTraceData(res?.data)
            }
        }).catch(() => {

        }).finally(() => {

        })

    }

    useEffect(() => {
        getTraceRequirement()
    }, [])

    const handleDeleteItems = async () => {
        const formdata = new FormData()
        formdata.append("organisation_id", getOrganisationId())
        // formdata.append("sales_order_id", quotationId)
        formdata.append("sales_core_id", currentSelection?.id)

        await PartSalesServices.deleteCoreItems(formdata).then((res) => {
            if (res?.success) {


                handleClose()
                message.showToastMessage({
                    message: "Core Item deleted successfully.",
                    variant: "success",
                });
            } else {

                message.showToastMessage({ message: res.errors ? res.errors.join(', ') : "Something went wrong. Try again", variant: "error" });
            }



        }).catch((response) => {
            message.showToastMessage({ message: response.errors ? response.errors.join(', ') : "Something went wrong. Try again", variant: "error" });
        }).finally(() => {
            setLoading(false)
        })


    }

    const handleCreateWorkshop = (id) => {
        const formData = new FormData()
        formData.append("sales_order_id", quotationId)
        formData.append("organisation_id", getOrganisationId())
        formData.append("user_id", getUserId())
        formData.append(`sales_order_core_id[0]`, id)
        PartSalesServices.createCoreExchange(formData).then((res) => {

        }).catch((e) => {

        })

    }
    const handleSubmit = async (e) => {
        e.preventDefault()

        const formData = new FormData(e.target)
        const { error, valid } = validateFormData(formData, [
            "",

        ]);

        if (!valid) {

            setLoading(null);
            setErrors(error);
            return;
        }

        let value1 = traceData.filter(item => item?.status).map((item) => {

            let obj = {
                "penalty_pc": item.penalty_pc,
                "value": item.value,
                "trace_item_id": item.id

            }
            return obj

        })
        const params = {
            "currency_id": currrencyDetails?.id,
            "sales_order_id": quotationId,
            "sales_order_item_id": linkedSales,
            "organisation_id": getOrganisationId(),
            "primary_part_id": primaryDetails?.id || primaryDetails?.primary_part_id,
            "sales_rate": currrencyDetails?.sales_rate,
            "core_type": coreType,
            "core_unit_value": unitValue,
            "quantity": qty,
            "core_line_total": lineTotal,
            "shipping": shippingFee,
            "receipt_type": receiptType,
            "receipt_days": tatQuantity,
            "late_day_charge": lateCharge,
            "trace_items": value1
        }


        const isCreate = action === "create";
        if (isCreate) {
            params["parent_status"] = tabName === "quote" ? 0 : null
            params["status"] = tabName === "quote" ? 0 : 1
        }

        const serviceMethod = isCreate
            ? PartSalesServices.createCoreItem
            : PartSalesServices.updateCoreItem;

        if (!isCreate) {
            params["sales_core_id"] = currentSelection?.id;
            // params["core_parent_id"] = currentSelection?.id;
        }
        else if (isCreate && coreId !== null) {
            let today = moment().format("DD/MM/YYYY")
            let date = moment(today, "DD/MM/YYYY").add(tatQuantity, "days").format("DD/MM/YYYY")
            params["core_parent_id"] = coreId
            params["due_date"] = date
        }
        try {
            const res = await serviceMethod(params);
            if (res?.success) {
                handleClose();
                message.showToastMessage({
                    message: isCreate
                        ? "Core Exchange created successfully."
                        : "Core Exchange updated successfully.",
                    variant: "success"
                });
                if (isCreate && coreId !== null && tabName !== "quote" && coreType === 0) {
                    handleCreateWorkshop(res?.sales_core_id)


                }
            }
        } catch (response) {
            message.showToastMessage({
                message: response?.errors?.join(', ') || "Something went wrong. Try again",
                variant: "error"
            });
        } finally {
            setLoading(null);
        }



    }

    // core unit total 

    useEffect(() => {
        if (unitValue !== null) {

            let quantity = qty || 0
            let value = (+unitValue) * (+quantity)
            setLineTotal(value)

        }
    }, [qty, unitValue])


    // 
    useEffect(() => {
        if (lineTotal !== undefined) {
            const calc = (quotationDetails.late_fee_value / 100) * lineTotal;
            setLateCharge(calc ? calc.toFixed(2) : 0); // 2 decimal places

        }
    }, [lineTotal, quotationDetails]);

    // customer rate calculation
    const calculateValue = (value, rate) => {
        if (!value || !rate || rate === 0) return 0;
        return parseFloat((value / rate).toFixed(2));
    };

    const rate = action === "create" ? currrencyDetails?.sales_rate : +currentSelection?.sale_rate
    useMemo(() => {


        const newResults = {
            coreUnitValue: calculateValue(+unitValue, rate),
            coreLineTotal: calculateValue(+lineTotal, rate),
            shipping: calculateValue(+shippingFee, rate),
            lateCharge: calculateValue(+lateCharge, rate),
        };

        setResults(newResults);
    }, [unitValue, lineTotal, shippingFee, lateCharge]);

    useEffect(() => {
        if (results?.coreLineTotal === undefined || results?.coreLineTotal === null || traceData.length === 0) return;

        const updatedTraceData = traceData.map((item) => ({
            ...item,
            value: handleTraceCalculation(item.penalty_pc, results.coreLineTotal),
        }));

        setTraceData(updatedTraceData);
    }, [results?.coreLineTotal]);

    useEffect(() => {
        if (action === "view" && currentSelection) {

            let type = {
                "MRO Collect": 1,
                "Customer Delivery": 0,
                "MRO Arranged 3rd Party": 2
            }
            let core_type = {
                "Service Order": 1,
                "Workshop Order": 0,

            }
            setUnitValue(currentSelection?.core_unit_value)
            setQty(currentSelection?.quantity)
            setLineTotal(currentSelection?.core_line_total)
            setPrimaryDetails({
                part_number: currentSelection?.part,
                description: currentSelection?.description,
                primary_part_id: currentSelection?.primary_part_id
            })
            setCoreType(core_type[currentSelection?.core_type])

            setLinkedSales(currentSelection?.sales_order_item_id)
            setShippingFee(currentSelection?.shipping_raw)
            setReceiptType(type[currentSelection?.receipt_type])
            setTatquantity(currentSelection?.receipt_days)
            setLateCharge(currentSelection?.late_day_charge)



        }
    }, [currentSelection])
    return (
        <MROFullScreenRightDrawer open={true}>

            <ToolBar handleClose={handleClose} titleName={"Core Exchange Item"} >{action === "view" && !disabled && currentSelection?.parent_status === "Quote" && <IconButton onClick={() => {
                handleDeleteItems()
            }}><Delete fontSize='small' /></IconButton>}</ToolBar>
            <div className={classes.wrapper}>

                {action === "create" && <>    <Typography color="primary" gutterBottom="15px" >
                    Search Repairable Parts
                </Typography>


                    <SearchBarWithFilters handleSearch={setSearchText} searchText={searchText} padding={'4px 16px'} placeholder={'Search'}
                    />

                    <Box mb={"10px"} mt={"10px"}>

                        <MaterialTable

                            icons={tableIcons}

                            columns={columns}
                            data={data || []}
                            isLoading={loading}


                            onChangePage={(page) => {
                                setPage(page);
                            }}
                            onChangeRowsPerPage={(pageSize) => {
                                setPageSize(pageSize);
                            }}
                            totalCount={totalCount}
                            page={page}
                            options={{
                                ...tableOptions,
                                rowStyle: rowData =>
                                ({
                                    backgroundColor: (primaryDetails?.primary_part_id === rowData.primary_part_id) ? `${alpha(theme.palette.secondary.main, 0.20)}` : '#FFF',
                                    height: "42px"
                                }),

                            }}
                        />
                    </Box></>}

                <Typography color="primary" gutterBottom="15px" >
                    Core Exchange Part
                </Typography>

                <form onSubmit={handleSubmit}>
                    <Grid
                        style={{ marginBottom: "10px" }}
                        container
                        spacing={3}
                        alignItems={"center"}
                        justify={"flex-start"}
                    >

                        <Grid className={classes.purchaseGrid} item xs={3}>
                            <MROTextField
                                name={"part_number"}
                                label={"Part *"}
                                placeholder={"Order # or reference"}
                                disabled={disabled}
                                InputLabelProps={{ shrink: true }}
                                value={primaryDetails?.part_number || ""}
                                InputProps={{
                                    className: classes.disableField
                                }}
                                error={errors?.part_number}

                            ></MROTextField>
                        </Grid>
                        <Grid className={classes.purchaseGrid} item xs={3}>
                            <MROTextField
                                name={"description"}
                                label={"Description *"}
                                placeholder={"Description"}
                                InputLabelProps={{ shrink: true }}
                                value={primaryDetails?.description || ""}
                                InputProps={{
                                    className: classes.disableField
                                }}
                                error={errors?.description}
                            ></MROTextField>
                        </Grid>    <Grid className={classes.purchaseGrid} item xs={3}>
                            <MROTextField
                                name={"sales_order_item_id"}
                                select
                                label={"Linked Sales Item *"}
                                placeholder={"select"}
                                value={linkedSales}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => {
                                    setLinkedSales(e.target.value)
                                }}
                                InputProps={{
                                    className: disabled && classes.disableField
                                }}
                                error={errors?.sales_order_item_id}
                            >
                                {/* <MenuItem value={"select"}> <span style={{ opacity: "40%" }}>Select</span></MenuItem> */}
                                {s_data && s_data?.map((list) => (
                                    <MenuItem key={list.id} value={list.id}>{list.part}</MenuItem>
                                ))}

                            </MROTextField>
                        </Grid>
                        <Grid className={classes.purchaseGrid} item xs={3}>
                            <MROTextField
                                name={"core_type"}
                                label={"Core Type *"}
                                placeholder={"Markup"}
                                select
                                InputLabelProps={{ shrink: true }}
                                value={coreType}
                                onChange={(e) => {
                                    setCoreType(e.target.value)
                                }}
                                InputProps={{
                                    className: (disabled || (action === "view" && currentSelection?.workshop_order_id !== null && coreType === 0
                                    )) && classes.disableField
                                }}
                                error={errors?.core_type}
                            >

                                <MenuItem value={0}>Internal</MenuItem>
                                <MenuItem value={1}>External</MenuItem>



                            </MROTextField>
                        </Grid>
                        <Grid className={classes.purchaseGrid} item xs={3}>
                            <MROTextField
                                name={"core_unit_value"}
                                label={"Core Unit Value *"}
                                placeholder={"Unit total"}
                                inputProps={{ maxLength: 30 }}
                                InputLabelProps={{ shrink: true }}
                                value={unitValue}
                                onChange={(e) => {
                                    let val = e.target.value;
                                    if (isNaN(val)) {
                                        val = val.replace(/[^0-9\.]/g, "");
                                        if (val.split(".").length > 2)
                                            val = val.replace(/\.+$/, "");
                                    }
                                    setUnitValue(val)
                                }}
                                error={errors?.core_unit_value}
                                InputProps={{

                                    className: disabled && classes.disableField,
                                    endAdornment: (<> <InputAdornment position="end" style={{ cursor: 'pointer' }}>

                                        <Typography color='primary' variant="subtitle2" style={{ fontSize: "14px" }}>{defaultCurrency?.rate}</Typography>
                                    </InputAdornment>

                                    </>),
                                }}
                            ></MROTextField>
                        </Grid>

                        <Grid className={classes.purchaseGrid} item xs={3}>
                            <QuantityCounter
                                name={"quantity"}
                                label={"Quantity *"}
                                // required
                                disabled={disabled}
                                placeholder={"Quantity"}
                                InputLabelProps={{ shrink: true, fontSize: "10px" }}
                                InputProps={{
                                    classes: {
                                        input: classes.inputEstimate,
                                    },
                                }}
                                autoFocus={errors["quantity"]}
                                error={errors["quantity"]}
                                helperText={
                                    errors["quantity"] &&
                                    (errors["quantity"]
                                        ? "QTY Required Must Be Greater Than 0"
                                        : `Please enter Quantity`)
                                }
                                setError={() =>
                                    setErrors((prevState) => ({
                                        ...prevState,
                                        quantity: false,
                                    }))
                                }
                                qty={qty}
                                setQty={setQty}
                            />
                        </Grid>
                        <Grid className={classes.purchaseGrid} item xs={3}>
                            <MROTextField
                                name={"core_line_total"}
                                label={"Core Line Total *"}
                                placeholder={"Unit total"}

                                InputLabelProps={{ shrink: true }}
                                value={lineTotal}
                                onChange={(e) => {

                                }}
                                error={errors?.core_line_total}
                                InputProps={{
                                    className: classes.disableField,
                                    endAdornment: (<> <InputAdornment position="end" style={{ cursor: 'pointer' }}>

                                        <Typography color='primary' variant="subtitle2" style={{ fontSize: "14px" }}>{defaultCurrency?.rate}</Typography>
                                    </InputAdornment>

                                    </>),
                                }}
                            ></MROTextField>

                        </Grid>




                    </Grid>


                    <Typography color="primary" gutterBottom="15px" >
                        Receipt Details
                    </Typography>

                    <Grid
                        style={{ marginBottom: "10px" }}
                        container
                        spacing={3}
                        alignItems={"center"}
                        justify={"flex-start"}
                    >

                        <Grid className={classes.purchaseGrid} item xs={3}>
                            <MROTextField
                                name={"receipt_type"}
                                label={"Receipt Type *"}
                                placeholder={"Line total"}
                                select
                                inputProps={{ maxLength: 30 }}
                                InputLabelProps={{ shrink: true }}
                                value={receiptType}
                                error={errors?.receipt_type}
                                onChange={(e) => {
                                    if (e.target.value === 0) {
                                        setShippingFee(0)
                                    }
                                    setReceiptType(e.target.value)
                                }}
                                InputProps={{
                                    className: disabled && classes.disableField
                                }}
                            >
                                <MenuItem value={0}>Customer Delivery</MenuItem>
                                <MenuItem value={1}>MRO Collect</MenuItem>
                                <MenuItem value={2}>MRO Arranged 3rd Party Agent</MenuItem>

                            </MROTextField>
                        </Grid>

                        <Grid className={classes.purchaseGrid} item xs={3}>
                            <MROTextField
                                name={"shipping"}
                                label={"Shipping *"}
                                placeholder={"Shipping Charge"}
                                error={errors?.shipping}
                                inputProps={{ maxLength: 30 }}
                                InputLabelProps={{ shrink: true }}
                                value={shippingFee}

                                onChange={(e) => {
                                    setShippingFee(e.target.value)
                                }}
                                InputProps={{
                                    className: receiptType === 0 || disabled ? classes.disableField : "",
                                    endAdornment: (<> <InputAdornment position="end" style={{ cursor: 'pointer' }}>

                                        <Typography color='primary' variant="subtitle2" style={{ fontSize: "14px" }}>{defaultCurrency?.rate}</Typography>
                                    </InputAdornment>

                                    </>),
                                }}
                            ></MROTextField>
                        </Grid>

                        <Grid className={classes.purchaseGrid} item xs={3}>

                            <QuantityCounter
                                name={"receipt_days"}
                                label={"Receipt Days *"}
                                // required
                                disabled={disabled}
                                placeholder={"Days"}
                                InputLabelProps={{ shrink: true, fontSize: "10px" }}
                                InputProps={{
                                    classes: {
                                        input: classes.inputEstimate,
                                    },
                                }}
                                autoFocus={errors["receipt_days"]}
                                error={errors["receipt_days"]}
                                helperText={errors["receipt_days"]
                                    ? `Please enter receipt` : ""
                                }
                                setError={() =>
                                    setErrors((prevState) => ({
                                        ...prevState,
                                        receipt_days: false,
                                    }))
                                }
                                qty={tatQuantity}
                                setQty={setTatquantity}
                            />



                        </Grid>
                        <Grid className={classes.purchaseGrid} item xs={3}>
                            <MROTextField
                                name={"late_day_charge"}
                                label={"Late Charge (Day) *"}
                                placeholder={"Line total"}

                                inputProps={{ maxLength: 30 }}
                                InputLabelProps={{ shrink: true }}
                                value={lateCharge}

                                onChange={(e) => {
                                    setLateCharge(e.target.value)
                                }}
                                InputProps={{
                                    className: disabled && classes.disableField,
                                    endAdornment: (<> <InputAdornment position="end" style={{ cursor: 'pointer' }}>

                                        <Typography color='primary' variant="subtitle2" style={{ fontSize: "14px" }}>{defaultCurrency?.rate}</Typography>
                                    </InputAdornment>

                                    </>),
                                }}
                            ></MROTextField>
                        </Grid>








                    </Grid>
                    <Typography color="primary" gutterBottom="15px" >
                        Customer’s Currency
                    </Typography>


                    <Box
                        display="flex"
                        alignItems="center"
                        bgcolor="#F5F5F5"
                        className={classes.partCard}
                    >
                        <Box flexGrow={1}>
                            <div style={{ width: "100%" }}>
                                <GetInfoCard
                                    keyName={"Currency"}
                                    value={currrencyDetails?.currency_name} color="primary"
                                />
                                <GetInfoCard

                                    keyName={"Rate"}
                                    value={currrencyDetails?.sales_rate} color="primary"
                                />

                            </div>
                        </Box>
                        <Box flexGrow={1}>
                            <div style={{ width: "100%" }}>
                                <GetInfoCard
                                    keyName={"Core Unit Value"}
                                    value={results?.coreUnitValue ?? "0.00"} color="primary"
                                />
                                <GetInfoCard
                                    keyName={"Core Line Total"}
                                    value={results?.coreLineTotal ?? "0.00"} color="primary"
                                />

                            </div>
                        </Box>
                        <Box flexGrow={1}>
                            <div style={{ width: "100%" }}>
                                <GetInfoCard
                                    keyName={"Shipping"}
                                    value={results?.shipping ?? "0.00"} color="primary"
                                />
                                <GetInfoCard
                                    keyName={"Late Charge (Day)"}
                                    value={results?.lateCharge ?? "0.00"} color="primary"
                                />

                            </div>
                        </Box>

                    </Box>
                    <Typography color="primary" gutterBottom="15px" style={{ marginTop: "15px" }}>
                        Trace Requirements
                    </Typography>
                    <TraceRequirements setData={setTraceData} data={traceData} getDefaultRequirement={getTraceRequirement} coreId={currentSelection?.id} action={action} coreLineTotal={results?.coreLineTotal} disabled={disabled} writePermission={props?.permission.write} />


                    {!disabled &&
                        <Grid item md={12} style={{ marginTop: "15px" }}>
                            <div className={"align-right"}>
                                <MROButton
                                    // loading={loading}
                                    style={{
                                        marginRight: "15px",
                                    }}
                                    variant={"contained"}

                                    onClick={() => handleClose()}
                                >
                                    Cancel
                                </MROButton>
                                <MROButton
                                    variant={"contained"}
                                    loading={loading === "complete"}
                                    type="submit"
                                    color="primary"
                                >
                                    {action === "create" ? "Complete" : "Update"}
                                </MROButton>
                            </div>
                        </Grid>}
                </form>




            </div>
            {cAction && cAction === "project_lookup" && (
                <PartPricing
                    handleClose={() => {
                        setCAction(null)
                    }}
                    currentWorkshopDetails={{ quantity: "1", part_number: currentSelectedData?.part_number, description: currentSelectedData?.description, salesRate: currrencyDetails?.sales_rate }}
                    name={"core"} salesRate={currrencyDetails?.sales_rate} currentSelectedData={currentSelectedData}
                />

            )}






        </MROFullScreenRightDrawer>
    )
}






